import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Shield, Mail } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si un compte existe, un email a été envoyé");
    } catch (err) {
      toast.error("Erreur, réessaie");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-lg bg-[#E5B85C] flex items-center justify-center">
            <Shield className="w-6 h-6 text-[#0B0F17]" strokeWidth={2.5} />
          </div>
          <div className="font-display font-black text-2xl uppercase">ASS les Régionnaires</div>
        </div>

        <div className="text-[11px] font-mono-stat uppercase tracking-[0.25em] text-slate-500 mb-3">
          Récupération
        </div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tight mb-3">
          Mot de passe oublié
        </h1>
        <p className="text-slate-400 mb-8 text-sm">
          Renseigne ton email : nous t'enverrons un lien pour choisir un nouveau mot de passe.
        </p>

        {sent ? (
          <div
            data-testid="forgot-password-sent"
            className="p-5 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-200 text-sm"
          >
            <div className="flex items-center gap-2 font-bold mb-2">
              <Mail className="w-4 h-4" /> Vérifie ta boîte mail
            </div>
            Si un compte est associé à cet email, tu recevras un lien de réinitialisation
            valable 1 heure. Pense à vérifier tes spams.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs font-mono-stat uppercase tracking-widest text-slate-400 mb-2">
                Email
              </label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-slate-900 border border-white/10 rounded-lg focus:border-[#E5B85C] focus:outline-none focus:ring-2 focus:ring-[#E5B85C]/20 text-white placeholder-slate-600"
                placeholder="votre.email@gmail.com"
              />
            </div>
            <button
              data-testid="forgot-submit-button"
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-[#E5B85C] hover:bg-[#D4A24E] text-[#0B0F17] font-bold uppercase tracking-wide rounded-lg disabled:opacity-50"
            >
              {loading ? "Envoi..." : "Envoyer le lien"}
            </button>
          </form>
        )}

        <div className="mt-6 text-center text-sm text-slate-400">
          <Link
            data-testid="back-to-login-link"
            to="/login"
            className="text-slate-300 hover:text-[#E5B85C] font-semibold"
          >
            ← Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
